<template>
  <div
    id="publish-box"
    class="d-flex align-items-center justify-content-center"
    @click.self="close"
  >
    <div class="center-box">
      <div class="mb-3 media">
        <h2 class="media-body">ตั้งค่าประกาศ</h2>
        <div class="ms-3">
          <div v-if="!isSavingArticle">
            <button
              v-if="!canPublish"
              class="btn sc-btn sc-btn-opaque"
              @click="requestArticle()"
            >
              {{ $t("button.request") }}
            </button>
            <button
              v-else-if="article.approvedAt === null && checkRolePublish()"
              :disabled="isPublishArticle"
              class="btn sc-btn sc-btn-opaque"
              @click="publishArticle()"
            >
              {{ $t("button.approve") }}
            </button>
          </div>
          <div v-else>
            <small>รอสักครู่ กำลังบันทึกข้อมูล...</small>
          </div>
        </div>
      </div>
      <div>
        <h3 class="mb-0">ตั้งเวลาที่จะประกาศข่าวนี้</h3>
        <div class="h4 col-12 col-md-6 p-0">
          <small>เลือกวันเวลาที่ต้องการ</small>
          <div class="clearfix">
            <el-date-picker
              v-model="publishAt"
              :default-time="['00:00:00', '23:59:59']"
              format="dd-MM-yyyy HH:mm"
              placeholder="ตั้งวัน / เวลา ที่จะประกาศ"
              type="datetime"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div>
        <h3 class="mb-0">ตั้งเวลาสิ้นสุดของข่าวนี้ (Optional)</h3>
        <div class="h4 col-12 col-md-6 p-0">
          <small>เลือกวันเวลาที่ต้องการ</small>
          <div class="clearfix">
            <el-date-picker
              v-model="expiredAt"
              format="dd-MM-yyyy HH:mm"
              placeholder="ตั้งวัน / เวลา สิ้นสุดประกาศ"
              type="datetime"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div>
        <h3 class="mt-4">พิมพ์ Tag เพื่อบอกประเภทของประกาศ</h3>
        <input-tag
          :tags="tagsArray"
          class="tags-wrapper"
          @updateTag="updateArticleTag"
        ></input-tag>
      </div>
    </div>
  </div>
</template>

<script>
import InputTag from "@/components/helper/InputTag"
import axios from "axios"
import Moment from "moment"
import { DatePicker } from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import { getCookie, Auth } from "@/lib/cookie"

export default {
  components: {
    InputTag,
    "el-date-picker": DatePicker,
  },
  props: {
    article: {
      type: null,
      default: undefined,
    },
    canPublish: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      tagsArray: this.setTags(),
      publishAt: this.getPublishAt(),
      expiredAt: this.getExpiredAt(),
      isSavingArticle: false,
      isPublishArticle: false,
    }
  },
  methods: {
    close() {
      this.$emit("update:close", "")
    },
    publishArticle() {
      this.isPublishArticle = true
      this.isSavingArticle = true

      if (this.article.articlesId && this.publishAt) {
        axios
          .post(
            `${process.env.HOST}/api/admin/articles/${
              this.article.articlesId
            }/publish`,
            {
              tag: this.tagsArray,
              publishAt: this.publishAt,
              expiredAt: this.expiredAt,
            },
            {
              headers: {
                Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              },
            },
          )
          .then((res) => {
            this.isSavingArticle = false

            if (res.status) {
              if (Moment(this.publishAt) < Moment()) {
                this.$router.push({
                  name: "ArticleListStatus",
                  params: {
                    articleType: this.$route.params.articleType,
                    articleStatus: "published",
                  },
                })
              } else {
                this.$router.push({
                  name: "ArticleListStatus",
                  params: {
                    articleType: this.$route.params.articleType,
                    articleStatus: "toBePublished",
                  },
                })
              }
            }

            this.isPublishArticle = false
          })
          .catch((e) => {
            this.isSavingArticle = false
            this.isPublishArticle = false

            throw e.message
          })
      }
    },
    requestArticle() {
      this.isSavingArticle = true

      if (this.article.articlesId && this.publishAt) {
        axios
          .post(
            `${process.env.HOST}/api/admin/articles/${
              this.article.articlesId
            }/request`,
            {
              tag: this.tagsArray,
              publishAt: this.publishAt,
              expiredAt: this.expiredAt,
            },
            {
              headers: {
                Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              },
            },
          )
          .then((res) => {
            this.isSavingArticle = false

            if (res.status) {
              this.$router.push({
                name: "ArticleListStatus",
                params: {
                  articleType: this.$route.params.articleType,
                  articleStatus: "toBeApproved",
                },
              })
            }
          })
          .catch((e) => {
            this.isSavingArticle = false

            throw e.message
          })
      }
    },
    setTags() {
      const tagsArr = []
      this.article.articlesTags.map((tag) => tagsArr.push(tag.tag))
      return tagsArr
    },
    getPublishAt() {
      if (this.article.publishAt) {
        return this.article.publishAt
      }

      return new Moment().add(1, "h").toISOString()
    },
    getExpiredAt() {
      if (this.article.expiredAt) {
        return this.article.expiredAt
      }

      return null
    },
    checkRolePublish() {
      if (localStorage.getItem("adminRole") <= 2) {
        return true
      }
      return false
    },
    updateArticleTag(tags) {
      this.tagsArray = tags
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  font-size: 24px;
  font-weight: bold;
  color: $black;
  line-height: 1.7;
}
h3 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.36;
  letter-spacing: -0.1px;
  color: $black;
}
small {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
}
#publish-box {
  background-color: rgba(74, 74, 74, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  margin: auto;
}
.center-box {
  position: absolute;
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
  width: 95%;
  /* height: 75%; */
  max-width: 475px;
  max-height: 95%;
  padding: 30px 20px;
  overflow-y: auto;
}
.tags-wrapper {
  border-radius: 5px;
  border: solid 1px #e0e0e0;
  min-height: 110px;
  padding: 10px;
}
.time-picker-wrapper {
  font-size: 18px;
  font-weight: bold;
  border: none;
  border-bottom: solid 1px #e0e0e0;
  height: 30px;
  margin-top: 5px;
  float: left;
  min-width: 220px;
}
.date-append-img {
  float: left;
  margin-top: 5px;
  margin-left: -25px;
}
</style>
